import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Nav,
  Modal,
  Form,
  ProgressBar,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//react-icons
import {
  FaStar,
  FaRegEdit,
  FaPlus,
  FaVideo,
  FaFileAlt,
  FaTrash,
  FaEye,
  FaEdit,
  FaRegEye,
} from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { BsFiletypePdf } from "react-icons/bs";
import { BiBookAdd } from "react-icons/bi";

import { toast } from "react-toastify";
import { CATEGORY_API, TUTOR_COURSE_API } from "../../../api/api";

import { initialsFromName } from "../../../utils/getInitials";
import { handleApiError } from "../../../utils/apiErrorHandler";

import noDataCourse from "../../../assets/student/no-data-course-watching.png";

import "./TutorMyCourse.css";

const TutorMyCourse = () => {
  const navigate = useNavigate();

  // COURSES
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [selectedCourseIndex, setSelectedCourseIndex] = useState(null);
  const [editingModuleIndex, setEditingModuleIndex] = useState(null);

  // COURSE FORM
  const [courseTitle, setCourseTitle] = useState("");
  const [courseDescription, setCourseDescription] = useState("");

  const [categories, setCategories] = useState([]);
  const [courseCategory, setCourseCategory] = useState("");

  const [courseLevel, setCourseLevel] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  // const [courseNumModules, setCourseNumModules] = useState("");

  const [createdCourseId, setCreatedCourseId] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);

  // MODULE FORM
  const [moduleTitle, setModuleTitle] = useState("");
  const [moduleDescription, setModuleDescription] = useState("");
  // const [moduleDuration, setModuleDuration] = useState("");
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [selectedAttachments, setSelectedAttachments] = useState([]);

  // const [videoNames, setVideoNames] = useState("");

  //  Edit Course
  const [editingCourseId, setEditingCourseId] = useState(null);

  //   Tabs per course
  const [activeTabsMap, setActiveTabsMap] = useState({});

  const [showAll, setShowAll] = useState(false);

  const [selectedStudent, setSelectedStudent] = useState(null);

  // course & Module Modal
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("createCourse"); // "createCourse" || "studentProgress"
  const [step, setStep] = useState(1);

  //   Delete course Modal
  const [showDeleteCourseModal, setShowDeleteCourseModal] = useState(false);
  const [deleteCourseIndex, setDeleteCourseIndex] = useState(null);

  //   Delete Modual  Modal
  const [showDeleteModuleModal, setShowDeleteModuleModal] = useState(false);
  const [deleteModuleIndex, setDeleteModuleIndex] = useState(null);

  //   Preview (module video preview)
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [mainVideo, setMainVideo] = useState(null);
  const [otherVideos, setOtherVideos] = useState([]);

  //loading
  const [isCreateCourseLoading, setIsCreateCourseLoading] = useState(false);
  const [isCreateModuleLoading, setIsCreateModuleLoading] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [isEditCourseLoading, setIsEditCourseLoading] = useState(false);
  const [isEditModuleLoading, setIsEditModuleLoading] = useState(false);
  const [isDeleteCourseLoading, setIsDeleteCourseLoading] = useState(false);
  const [isDeleteModuleLoading, setIsDeleteModuleLoading] = useState(false);

  const videoInputRef = useRef(null);
  const attachmentInputRef = useRef(null);

  // ID's
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("user_id");

  const handleAttachmentChange = (e) => {
    const file = e.target.files[0]; // take only the first file
    if (file) {
      setSelectedAttachments([{ name: file.name, file }]);
    }
  };

  const handleVideoChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      const newVideos = files.map((f) => ({
        name: f.name,
        file: f, // actual File object
        module_video_id: null, // new uploads have no ID yet
      }));

      // append new videos to existing ones
      const updatedVideos = [...selectedVideos, ...newVideos];

      setSelectedVideos(updatedVideos);
      // setVideoNames(updatedVideos.map((v) => v.name).join(", "));
    }
  };

  const setActiveTabForCourse = (courseId, tab) =>
    setActiveTabsMap((prev) => ({ ...prev, [courseId]: tab }));

  const handleRemoveVideo = (index) => {
    setSelectedVideos((prev) => prev.filter((_, i) => i !== index));
    if (videoInputRef.current) videoInputRef.current.value = "";
  };

  const handleRemoveAttachment = (index) => {
    setSelectedAttachments((prev) => prev.filter((_, i) => i !== index));
    if (attachmentInputRef.current) attachmentInputRef.current.value = "";
  };

  const allowedRegex = /^[a-zA-Z .,'()&/-]+$/;

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  const fetchCategories = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    try {
      const response = await axios.get(CATEGORY_API.GET_CATEGORY, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;

      if (data.statusCode === 200) {
        setCategories(data.category);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Fetch categories error:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  }, [navigate]);

  const fetchTutorCourses = useCallback(async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setLoadingCourses(false);
      navigate("/signin");
      return;
    }

    try {
      const response = await axios.post(
        TUTOR_COURSE_API.GET_TOTAL_COURSE,
        { tutor_id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        setCourses(data.data || []);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Fetch courses error:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setLoadingCourses(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchCategories();
    fetchTutorCourses();
  }, [fetchCategories, fetchTutorCourses]);

  // course function
  const handleShowCreateCourse = () => {
    setModalType("createCourse");
    setSelectedCourseIndex(null); // new course
    setModules([]);
    setEditingModuleIndex(null);
    // reset course fields
    setCourseTitle("");
    setCourseDescription("");
    setCourseCategory("");
    setCourseLevel("");
    setCourseDuration("");
    // setCourseNumModules("");
    setStep(1);
    setShowModal(true);
  };

  //   Edit Course (open modal & apply update)
  const handleOpenEditCourse = (courseId) => {
    const selected = courses.find((c) => c.course_id === courseId);
    if (!selected) return;

    setEditingCourseId(courseId);

    // PREFILL FORM FIELDS
    setCourseTitle(selected.course_title || "");
    setCourseDescription(selected.course_description || "");
    setCourseCategory(selected.category?.category_id || "");
    setCourseLevel(selected.level || "");
    setCourseDuration(selected.duration || "");
    // setCourseNumModules(selected.no_of_modules || "");

    // OPEN STEP 1 MODAL
    setStep(1);
    setModalType("createCourse");
    setShowModal(true);
  };

  const handleOpenAddModule = (courseId) => {
    const courseExists = courses.some((c) => c.course_id === courseId);

    if (!courseExists) {
      showErrorToast("Course not found:", courseId);
      return;
    }

    setModalType("createCourse");
    setSelectedCourseId(courseId);
    setEditingModuleIndex(null);

    // IMPORTANT: only NEW modules
    setModules([]);

    setStep(2); // Directly Step 2
    setShowModal(true);
  };

  // module functio
  const resetModuleFields = () => {
    setModuleTitle("");
    setModuleDescription("");
    // setModuleDuration("");
    setSelectedVideos([]);
    setSelectedAttachments([]);
    // setVideoNames("");
    if (videoInputRef.current) videoInputRef.current.value = "";
    if (attachmentInputRef.current) attachmentInputRef.current.value = "";
    setEditingModuleIndex(null);
    setSelectedCourseIndex(null);
  };

  // MODAL HANDLERS
  const handleCloseModal = () => {
    setShowModal(false);

    // reset course form
    setCourseTitle("");
    setCourseDescription("");
    setCourseCategory("");
    setCourseLevel("");
    setCourseDuration("");
    // setCourseNumModules("");

    // reset course step fields if desired
    setStep(1);
    resetModuleFields();
    setSelectedCourseIndex(null);
    setEditingModuleIndex(null);
    setEditingCourseId(null);
  };

  // ALL MODULE RELATED API'S
  const handleAddCourse = async (e) => {
    e.preventDefault();
    setIsCreateCourseLoading(true);
    if (
      !courseTitle ||
      !courseDescription ||
      !courseCategory ||
      !courseDuration ||
      // !courseNumModules ||
      !courseLevel
    ) {
      showErrorToast("Please fill all fields");
      return;
    }

    // Course Title validation
    if (!allowedRegex.test(courseTitle)) {
      showErrorToast("Course title should contain only alphabets");
      setIsCreateCourseLoading(false);
      return;
    }

    // Description validation
    if (courseDescription.length < 30) {
      showErrorToast("Description must be at least 30 characters.");
      setIsCreateCourseLoading(false);
      return;
    }

    if (!/[a-zA-Z]/.test(courseDescription)) {
      showErrorToast("Description must contain at least one letter");
      setIsCreateCourseLoading(false);
      return;
    }

    // Duration validation
    if (!/^\d+\sDays$/.test(courseDuration)) {
      showErrorToast("Duration must be like '15 Days'");
      setIsCreateCourseLoading(false);
      return;
    }

    if (!token || !userId) {
      navigate("/signin");
      return;
    }

    const payload = {
      category_id: courseCategory,
      tutor_id: userId,
      course_title: courseTitle,
      course_description: courseDescription,
      duration: courseDuration,
      // no_of_modules: courseNumModules,
      level: courseLevel,
    };

    try {
      const response = await axios.post(TUTOR_COURSE_API.ADD_COURSE, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorCourses();

        const newCourseId = data.course_id?.course_id;

        setCreatedCourseId(newCourseId);
        setStep(2);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (err) {
      console.error("Add course error:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    } finally {
      setIsCreateCourseLoading(false);
    }
  };

  const handleEditCourse = async (e) => {
    e.preventDefault();
    setIsEditCourseLoading(true);

    if (!editingCourseId) return;

    if (
      !courseTitle ||
      !courseDescription ||
      !courseCategory ||
      !courseDuration ||
      // !courseNumModules ||
      !courseLevel
    ) {
      showErrorToast("Please fill all fields");
      setIsEditCourseLoading(false);
      return;
    }

    // Course Title validation
    if (!allowedRegex.test(courseTitle)) {
      showErrorToast("Course title should contain only alphabets");
      setIsEditCourseLoading(false);
      return;
    }

    // Description validation
    if (courseDescription.length < 30) {
      showErrorToast("Description must be at least 30 characters");
      setIsEditCourseLoading(false);
      return;
    }

    if (!/[a-zA-Z]/.test(courseDescription)) {
      showErrorToast("Description must contain at least one letter");
      setIsEditCourseLoading(false);
      return;
    }

    // Duration validation
    if (!/^\d+\sDays$/.test(courseDuration)) {
      showErrorToast("Duration must be in format like '15 Days'");
      setIsEditCourseLoading(false);
      return;
    }

    if (!token || !userId) {
      navigate("/signin");
      return;
    }

    const payload = {
      course_id: editingCourseId,
      tutor_id: userId,
      category_id: courseCategory,
      course_title: courseTitle,
      course_description: courseDescription,
      duration: courseDuration,
      // no_of_modules: courseNumModules,
      level: courseLevel,
    };

    try {
      const response = await axios.post(
        TUTOR_COURSE_API.UPDATE_COURSE,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        fetchTutorCourses();
        handleCloseModal();
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (err) {
      console.error("Update course error:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    } finally {
      setIsEditCourseLoading(false);
    }
  };

  const handleAddModule = () => {
    if (
      !moduleTitle ||
      !moduleDescription ||
      selectedVideos.length === 0 ||
      selectedAttachments.length === 0
    ) {
      showErrorToast("Please fill all fields");
      return;
    }

    const titleHasLetter = /[a-zA-Z]/.test(moduleTitle);
    if (!titleHasLetter) {
      showErrorToast("Module title must contain at least one letter");
      return;
    }

    const descHasLetter = /[a-zA-Z]/.test(moduleDescription);
    if (!descHasLetter) {
      showErrorToast("Module description must contain at least one letter");
      return;
    }

    if (moduleDescription.length < 30) {
      showErrorToast("Module description must be at least 30 characters");
      return;
    }

    const newModule = {
      title: moduleTitle,
      description: moduleDescription,
      // duration: moduleDuration,
      videos: selectedVideos.map((v) => ({
        name: v.name,
        file: v.file || null,
      })),
      attachments: selectedAttachments.map((a) => ({
        name: a.name,
        file: a.file || null,
      })),
    };

    setModules((prev) => [...prev, newModule]);

    resetModuleFields();
    // setStep(2);
  };

  // const handleEditLocalModule = (moduleIndex) => {
  //   const mod = modules?.[moduleIndex];
  //   if (!mod) return;

  //   setEditingModuleIndex(moduleIndex);
  //   setModuleTitle(mod.title || "");
  //   setModuleDescription(mod.description || "");
  //   setSelectedVideos(Array.isArray(mod.videos) ? mod.videos : []);
  //   setSelectedAttachments(
  //     Array.isArray(mod.attachments) ? mod.attachments : []
  //   );
  //   setVideoNames(
  //     Array.isArray(mod.videos) ? mod.videos.map((v) => v.name).join(", ") : ""
  //   );

  //   setStep(2); // Ensure modal shows step 2 for module editing
  //   setShowModal(true); // Open modal if not already
  // };

  const handleCreateModule = async () => {
    if (!modules.length) {
      showErrorToast("Add at least one module before creating the course");
      return;
    }
    setIsCreateModuleLoading(true);
    try {
      const courseId = selectedCourseId || createdCourseId; // use course_id directly

      const formData = new FormData();
      formData.append("course_id", courseId);

      // Add modules as JSON string
      formData.append(
        "modules",
        JSON.stringify(
          modules.map((mod) => ({
            module_title: mod.title,
            module_description: mod.description,
          })),
        ),
      );
      // Add attachments for each module
      modules.forEach((mod, modIndex) => {
        mod.attachments?.forEach((file) => {
          formData.append(`sheet_files[${modIndex}]`, file.file);
        });
      });

      // Add videos for each module
      modules.forEach((mod, modIndex) => {
        mod.videos?.forEach((video, vidIndex) => {
          formData.append(`video_files[${modIndex}][${vidIndex}]`, video.file);
        });
      });

      const response = await axios.post(TUTOR_COURSE_API.ADD_MODULE, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorCourses();
        // Reset everything after successful upload
        setModules([]);
        setModuleTitle("");
        setModuleDescription("");
        setSelectedVideos([]);
        setSelectedAttachments([]);
        setCourseTitle("");
        setCourseDescription("");
        setCourseCategory("");
        setCourseLevel("");
        setCourseDuration("");
        // setCourseNumModules("");
        setShowModal(false);
        setStep(1);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (err) {
      console.error("Add module error:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    } finally {
      setIsCreateModuleLoading(false);
    }
  };

  const handleEditModule = (course_id, module_id) => {
    // find the course first
    const course = courses.find((c) => c.course_id === course_id);
    if (!course) return;

    // find module
    const mod = course.modules.find((m) => m.module_id === module_id);
    if (!mod) return;

    setSelectedCourseIndex(courses.indexOf(course));
    setEditingModuleIndex(course.modules.indexOf(mod));

    setModuleTitle(mod.module_title || "");
    setModuleDescription(mod.module_description || "");

    // normalize videos
    const normalizedVideos =
      mod.videos?.map((v) => ({
        name: v.video_title || v.name, // display name
        file: null, // no file for existing
        module_video_id: v.module_video_id, // keep ID for API
      })) || [];

    setSelectedVideos(normalizedVideos);
    // setVideoNames(normalizedVideos.map((v) => v.name).join(", "));

    setSelectedAttachments(
      mod.sheet_file
        ? [
            {
              name: mod.sheet_file
                .split("/")
                .pop()
                .split("_")
                .slice(1)
                .join("_"),
              file: null,
            },
          ]
        : [],
    );

    setStep(2);
    setShowModal(true); // open modal with selected module data
  };

  const handleUpdateModule = async () => {
    if (editingModuleIndex === null || selectedCourseIndex === null) {
      showErrorToast("No module selected for updating");
      return;
    }

    const course = courses[selectedCourseIndex];
    const moduleToUpdate = course.modules[editingModuleIndex];

    if (!moduleToUpdate) {
      showErrorToast("Module not found");
      return;
    }

    if (
      !moduleTitle ||
      !moduleDescription ||
      selectedVideos.length === 0 ||
      selectedAttachments.length === 0
    ) {
      showErrorToast("Please fill all fields");
      return;
    }

    setIsEditModuleLoading(true);

    try {
      const formData = new FormData();

      // Module details
      formData.append("module_id", moduleToUpdate.module_id);
      formData.append("module_title", moduleTitle);
      formData.append("module_description", moduleDescription);

      // Existing videos (send IDs only)
      moduleToUpdate.videos?.forEach((video) => {
        formData.append("module_video_id[]", video.module_video_id);
      });

      // New video files
      selectedVideos.forEach((video) => {
        if (video.file) {
          formData.append("video_files", video.file);
        }
      });

      // Attachment (sheet file)
      selectedAttachments.forEach((attachment) => {
        if (attachment.file) {
          formData.append("sheet_file", attachment.file);
        }
      });

      const response = await axios.post(
        TUTOR_COURSE_API.UPDATE_MODULE_VIDEOS,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        // Refresh courses or update local state
        fetchTutorCourses();

        // Reset modal fields
        resetModuleFields();
        setShowModal(false);
        setStep(2);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (err) {
      console.error("Update module error:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    } finally {
      setIsEditModuleLoading(false);
    }
  };

  // const handleBackStep = () => setStep(1);

  const handlePreviewModule = (courseId, moduleId) => {
    const course = courses.find((c) => c.course_id === courseId);
    if (!course) return;

    const mod = course.modules.find((m) => m.module_id === moduleId);
    if (!mod) return;

    const videos = mod.videos || [];

    setPreviewData(mod);
    setMainVideo(videos[0] || null); // first video as main
    setOtherVideos(videos.slice(1) || []); // rest as other videos
    setShowPreview(true);
  };

  const swapVideo = (clickedVideo, index) => {
    const newOther = [...otherVideos];
    const temp = mainVideo;
    setMainVideo(clickedVideo);
    newOther[index] = temp;
    setOtherVideos(newOther);
  };

  //   Delete model Course
  const askDeleteCourse = (courseId) => {
    setDeleteCourseIndex(courseId);
    setShowDeleteCourseModal(true);
  };

  const handleConfirmDeleteCourse = async () => {
    if (!deleteCourseIndex) return;

    setIsDeleteCourseLoading(true);
    try {
      const response = await axios.post(
        TUTOR_COURSE_API.DELETE_COURSE,
        { course_id: deleteCourseIndex },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        // Remove course from local state
        setCourses((prev) =>
          prev.filter((c) => c.course_id !== deleteCourseIndex),
        );
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (err) {
      console.error("Delete course error:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    } finally {
      setIsDeleteCourseLoading(false);
      setShowDeleteCourseModal(false);
      setDeleteCourseIndex(null);
    }
  };

  const handleCancelDeleteCourse = () => {
    setShowDeleteCourseModal(false);
    setDeleteCourseIndex(null);
  };

  //   Delete model Module
  const askDeleteLocalModule = (localIndex) => {
    setSelectedCourseIndex(null); // null = local
    setDeleteModuleIndex(localIndex); // index in local modules array
    setShowDeleteModuleModal(true);
  };

  const askDeleteApiModule = (courseId, moduleId) => {
    setSelectedCourseIndex(courseId);
    setDeleteModuleIndex(moduleId);
    setShowDeleteModuleModal(true);
  };

  const handleConfirmDeleteModule = async () => {
    if (deleteModuleIndex === null || deleteModuleIndex === undefined) return;

    setIsDeleteModuleLoading(true);
    try {
      if (selectedCourseIndex !== null && selectedCourseIndex !== undefined) {
        const response = await axios.post(
          TUTOR_COURSE_API.DELETE_MODULE,
          { module_id: deleteModuleIndex },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          toast.success(data.message, {
            position: "top-right",
            autoClose: 1500,
            theme: "colored",
          });

          // Remove module from local state
          setCourses((prev) => {
            const updated = [...prev];
            const courseIndex = prev.findIndex(
              (c) => c.course_id === selectedCourseIndex,
            );
            if (courseIndex > -1) {
              updated[courseIndex].modules = updated[
                courseIndex
              ].modules.filter((m) => m.module_id !== deleteModuleIndex);
            }
            return updated;
          });
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } else {
        // --- Local module delete (not yet saved) ---
        setModules((prev) => prev.filter((_, i) => i !== deleteModuleIndex));
        toast.success("Module removed successfully!", {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
      }
    } catch (err) {
      console.error("Delete module error:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    } finally {
      // reset modal & loading state
      setIsDeleteModuleLoading(false);
      setShowDeleteModuleModal(false);
      setDeleteModuleIndex(null);
      setSelectedCourseIndex(null);
    }
  };

  const handleCancelDeleteModule = () => {
    setShowDeleteModuleModal(false);
    setDeleteModuleIndex(null);
    setSelectedCourseIndex(null);
  };

  //   Student progress
  const handleStudentDetailsView = async (studentId, courseId) => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");

      return;
    }

    try {
      const response = await axios.post(
        TUTOR_COURSE_API.GET__TUTORS_STUDENT_DETAILS_BY_ID,
        { course_id: courseId, student_id: studentId },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        const studentData = data.data;

        setSelectedStudent({
          profile: studentData.profile,
          overall_progress: studentData.overall_progress,
          recent_activity: studentData.recent_activity,
        });

        setModalType("studentProgress");
        setShowModal(true);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error student details:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  return (
    <Container className="tutor-mycourse-section">
      <div className="tutor-mycourse-header">
        <div>
          <h2 className="tutor-mycourse-title">My Courses</h2>
          <p className="tutor-mycourse-subtext">
            Manage your courses, modules, and student enrollments.
          </p>
        </div>
        <Button
          className="tutor-mycourse-new-create-btn"
          onClick={handleShowCreateCourse}
        >
          + Create Course
        </Button>
      </div>

      {loadingCourses ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : courses.length === 0 ? (
        <div className="tutor-mycourse-module-emptypart-wrapper">
          <div className="tutor-mycourse-module-emptypart-container">
            <div className="tutor-mycourse-module-emptypart-icon">
              <img
                src={noDataCourse}
                alt="No courses"
                className="tutor-mycourse-module-emptypart-img"
              />
            </div>
            <p className="tutor-mycourse-module-emptypart-title">
              No courses available.
            </p>
            <p className="tutor-mycourse-module-emptypart-subtitle">
              Click Create Course to add your first course.
            </p>
            {/* <Button
              className="tutor-mycourse-module-emptypart-button"
              onClick={handleShowCreateCourse}
            >
              + Create Course
            </Button> */}
          </div>
        </div>
      ) : (
        <>
          {courses.map((course, courseIndex) => {
            const localActiveTab =
              activeTabsMap[course.course_id] || "mycourses";

            // Students for this course
            const visibleStudents = showAll
              ? course.students || []
              : (course.students || []).slice(0, 6);
            return (
              <Card key={course.course_id} className="tutor-mycourse-card mb-4">
                <Card.Body className="p-0">
                  <div className="mb-3">
                    <div className="tutor-mycourse-mainpart">
                      <h6 className="tutor-mycourse-name">
                        {course.course_title || "N/A"}{" "}
                        <span
                          className={`tutor-mycourse-status
                          ${
                            course.status?.toLowerCase() === "published"
                              ? "tutor-status-published"
                              : ""
                          }
                          ${
                            course.status?.toLowerCase() === "pending"
                              ? "tutor-status-pending"
                              : ""
                          }
                          ${
                            course.status?.toLowerCase() === "rejected"
                              ? "tutor-status-rejected"
                              : ""
                          }`}
                        >
                          {course.status || "N/A"}
                        </span>
                      </h6>
                      <div className="mb-2 d-flex gap-2">
                        {/* EDIT COURSE */}
                        {course.status?.toLowerCase() === "rejected" && (
                          <Button
                            className="tutor-mycourse-btn"
                            onClick={() =>
                              handleOpenEditCourse(course.course_id)
                            }
                          >
                            <FaRegEdit /> Edit
                          </Button>
                        )}

                        {/* ADD MODULE */}
                        {course.status?.toLowerCase() !== "published" && (
                          <Button
                            className="tutor-mycourse-btn"
                            onClick={() =>
                              handleOpenAddModule(course.course_id)
                            }
                          >
                            <FaPlus /> Add Module
                          </Button>
                        )}

                        {/* DELETE COURSE */}
                        {course.status?.toLowerCase() === "pending" && (
                          <Button
                            className="tutor-mycourse-btn"
                            onClick={() => askDeleteCourse(course.course_id)}
                          >
                            <FaTrash /> Delete
                          </Button>
                        )}
                      </div>
                    </div>

                    <p className="tutor-mycourse-desc">
                      {course.course_description || "N/A"}
                    </p>
                  </div>

                  {/* ==== Tabs ==== */}
                  <Row className="justify-content-start">
                    <Col lg={4} md={8} sm={12}>
                      <Nav variant="tabs" className="tutor-mycourse-tabs">
                        <Nav.Item>
                          <Nav.Link
                            active={localActiveTab === "mycourses"}
                            onClick={() =>
                              setActiveTabForCourse(
                                course.course_id,
                                "mycourses",
                              )
                            }
                          >
                            My Courses
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            active={localActiveTab === "modules"}
                            onClick={() =>
                              setActiveTabForCourse(course.course_id, "modules")
                            }
                          >
                            Modules
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            active={localActiveTab === "students"}
                            onClick={() =>
                              setActiveTabForCourse(
                                course.course_id,
                                "students",
                              )
                            }
                          >
                            Students
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                  </Row>

                  {/* TAB CONTENTS */}
                  {localActiveTab === "mycourses" && (
                    <div className="tutor-mycourse-main-section">
                      <div className="tutor-mycourse-info-grid">
                        <div className="tutor-mycourse-info-box">
                          <p>Enrolled</p>
                          <h6>{course.enrolled_count || "-"}</h6>
                        </div>
                        <div className="tutor-mycourse-info-box">
                          <p>Modules</p>
                          <h6>{course.no_of_modules || "-"}</h6>
                        </div>
                        <div className="tutor-mycourse-info-box">
                          <p>Duration</p>
                          <h6>{course.duration || "-"}</h6>
                        </div>
                        <div className="tutor-mycourse-info-box">
                          <p>Rating</p>
                          <h6>
                            <FaStar className="me-1" />
                            {course.avg_rating || "N/A"}
                          </h6>
                        </div>
                      </div>

                      <Row className="tutor-mycourse-bottom">
                        <Col md={6}>
                          <p>Category:</p>
                          <h6>{course.category?.category_name || "N/A"}</h6>
                        </Col>
                        <Col md={6}>
                          <p>Level:</p>
                          <h6>{course.level || "N/A"}</h6>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {localActiveTab === "modules" && (
                    <div className="tutor-mycourse-modules-section">
                      {course.modules?.length > 0 ? (
                        course.modules.map((mod, i) => (
                          <Card
                            key={mod.module_id}
                            className="tutor-mycourse-module-card mb-3 p-3"
                          >
                            <div className="tutor-mycourse-module-header">
                              <h6 className="tutor-mycourse-module-title">
                                <span className="tutor-mycourse-module-id">
                                  {i + 1}
                                </span>{" "}
                                {mod.module_title}
                                <span
                                  className={`tutor-mycourse-status ${
                                    mod.videos.some(
                                      (video) =>
                                        video.status?.toLowerCase() ===
                                        "published",
                                    )
                                      ? "tutor-status-published"
                                      : mod.videos.some(
                                            (video) =>
                                              video.status?.toLowerCase() ===
                                              "pending",
                                          )
                                        ? "tutor-status-pending"
                                        : mod.videos.some(
                                              (video) =>
                                                video.status?.toLowerCase() ===
                                                "rejected",
                                            )
                                          ? "tutor-status-rejected"
                                          : ""
                                  }`}
                                >
                                  {mod.videos.some(
                                    (video) =>
                                      video.status?.toLowerCase() ===
                                      "rejected",
                                  )
                                    ? "Rejected"
                                    : mod.videos.some(
                                          (video) =>
                                            video.status?.toLowerCase() ===
                                            "pending",
                                        )
                                      ? "Pending"
                                      : mod.videos.every(
                                            (video) =>
                                              video.status?.toLowerCase() ===
                                              "published",
                                          )
                                        ? "Published"
                                        : "N/A"}
                                </span>
                              </h6>

                              <div className="tutor-mycourse-action-buttons d-flex gap-2">
                                {mod.videos.some(
                                  (video) =>
                                    video.status?.toLowerCase() === "rejected",
                                ) && (
                                  <Button
                                    variant="outline-success"
                                    size="sm"
                                    className="tutor-mycourse-btn tutor-btn-edit"
                                    onClick={() =>
                                      handleEditModule(
                                        course.course_id,
                                        mod.module_id,
                                      )
                                    }
                                  >
                                    <FaEdit /> Edit
                                  </Button>
                                )}

                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  className="tutor-mycourse-btn tutor-btn-preview"
                                  onClick={() =>
                                    handlePreviewModule(
                                      course.course_id,
                                      mod.module_id,
                                    )
                                  }
                                >
                                  <FaEye /> Preview
                                </Button>

                                {mod.videos.some(
                                  (video) =>
                                    video.status?.toLowerCase() === "pending",
                                ) && (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    className="tutor-mycourse-btn tutor-btn-delete"
                                    onClick={() =>
                                      askDeleteApiModule(
                                        course.course_id,
                                        mod.module_id,
                                      )
                                    }
                                  >
                                    <FaTrash /> Delete
                                  </Button>
                                )}
                              </div>
                            </div>

                            <p className="tutor-mycourse-module-description text-muted">
                              {mod.module_description || "N/A"}
                            </p>

                            <div className="tutor-mycourse-module-buttons d-flex flex-wrap gap-2 mb-3">
                              {mod.videos?.map((video, j) => (
                                <Button
                                  key={video.module_video_id}
                                  variant="outline-primary"
                                  className="tutor-mycourse-btn"
                                >
                                  <FaVideo /> {video.video_title || "N/A"}
                                </Button>
                              ))}
                              {mod.sheet_file && (
                                <Button
                                  variant="outline-secondary"
                                  className="tutor-mycourse-btn"
                                >
                                  <FaFileAlt />{" "}
                                  {mod.sheet_file
                                    .split("/")
                                    .pop()
                                    .split("_")
                                    .slice(1)
                                    .join("_")}
                                </Button>
                              )}
                            </div>
                          </Card>
                        ))
                      ) : (
                        <div className="tutor-mycourse-module-emptypart-wrapper">
                          <div className="tutor-mycourse-module-emptypart-container">
                            <div className="tutor-mycourse-module-emptypart-icon">
                              <BiBookAdd size={40} color="#4A90E2" />
                            </div>
                            <p className="tutor-mycourse-module-emptypart-title">
                              No modules available.
                            </p>
                            <p className="tutor-mycourse-module-emptypart-subtitle">
                              Click Add Module to create your first module and
                              organize your course content.
                            </p>
                            {/* <Button
                              className="tutor-mycourse-module-emptypart-button"
                              onClick={() =>
                                handleOpenAddModule(course.course_id)
                              }
                            >
                              + Add Modules
                            </Button> */}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {localActiveTab === "students" && (
                    <div className="tutor-mycourse-students-section">
                      {course.students && course.students.length > 0 ? (
                        <>
                          <div className="row g-3">
                            {visibleStudents.map((student) => (
                              <div
                                key={student.student_id}
                                className="col-md-4 col-sm-6"
                              >
                                <Card className="tutor-student-card">
                                  <div className="d-flex align-items-start justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                      <div className="tutor-student-avatar">
                                        {initialsFromName(student.student_name)}
                                      </div>
                                      <div>
                                        <h6 className="mb-0 tutor-student-name">
                                          {student.student_name}
                                        </h6>
                                        {/* <small className="tutor-student-name-progresses">
                                          Progress: {student.progress}%
                                        </small> */}
                                      </div>
                                    </div>
                                    <Button
                                      variant="outline-secondary"
                                      size="sm"
                                      className="tutor-btn-view"
                                      onClick={() =>
                                        handleStudentDetailsView(
                                          student.student_id,
                                          course.course_id,
                                        )
                                      }
                                    >
                                      <FaRegEye /> View
                                    </Button>
                                  </div>
                                </Card>
                              </div>
                            ))}
                          </div>

                          {course.students.length > 6 && (
                            <div className="text-center mt-4">
                              <button
                                className="btn btn-link tutor-view-all-btn"
                                onClick={() => setShowAll(!showAll)}
                              >
                                {showAll ? "View less" : "View all Students"}
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="tutor-mycourse-module-emptypart-wrapper">
                          <div className="tutor-mycourse-module-emptypart-container">
                            <div className="tutor-mycourse-module-emptypart-icon">
                              <BiBookAdd size={40} color="#4A90E2" />
                            </div>
                            <p className="tutor-mycourse-module-emptypart-title">
                              No students enrolled yet.
                            </p>
                            <p className="tutor-mycourse-module-emptypart-subtitle">
                              Students who enroll in your courses will appear
                              here.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </Card.Body>
              </Card>
            );
          })}
        </>
      )}

      {/* CREATE COURSE / ADD MODULE MODAL */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
        className="tutor-mycourse-modal p-0"
        dialogClassName="tutor-mycourse-modal-dialog"
        contentClassName="tutor-mycourse-modal-content"
      >
        {modalType === "createCourse" ? (
          <>
            <Modal.Header closeButton className="tutor-mycourse-model-header">
              <Modal.Title>
                {step === 1
                  ? editingCourseId
                    ? "Edit Course – Step 1: Course Details"
                    : "Create New Course – Step 1: Course Details"
                  : editingCourseId
                    ? `Edit Course – Step 2: Manage Modules (${
                        courses[selectedCourseIndex]?.modules?.length ||
                        modules.length
                      } added)`
                    : `Create New Course – Step 2: Add / Edit Modules (${modules.length} added)`}
              </Modal.Title>
            </Modal.Header>

            <p className="tutor-mycourse-model-header-p">
              {step === 1
                ? "Fill in the course details, then add modules with videos"
                : "Add modules with video content for your course"}
            </p>

            <Modal.Body>
              {step === 1 ? (
                <Form
                  onSubmit={
                    editingCourseId ? handleEditCourse : handleAddCourse
                  }
                >
                  <Form.Group className="mb-3">
                    <Form.Label>Course Title</Form.Label>
                    <Form.Control
                      name="courseTitle"
                      type="text"
                      value={courseTitle}
                      onChange={(e) => setCourseTitle(e.target.value)}
                      placeholder="E.g., Advanced React Development"
                      className="tutor-mycourse-input"
                      // pattern="[A-Za-z ]+"
                      // title="Only alphabets are allowed"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      name="courseDescription"
                      as="textarea"
                      rows={3}
                      value={courseDescription}
                      onChange={(e) => setCourseDescription(e.target.value)}
                      placeholder="Describe what students will learn..."
                      className="tutor-mycourse-textarea"
                      required
                    />
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Category</Form.Label>
                        <Form.Select
                          value={courseCategory}
                          onChange={(e) => setCourseCategory(e.target.value)}
                          className="tutor-mycourse-input"
                          required
                        >
                          <option value="">Select Category</option>
                          {categories.map((cat) => (
                            <option
                              key={cat.category_id}
                              value={cat.category_id}
                            >
                              {cat.category_name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Level</Form.Label>
                        <Form.Select
                          value={courseLevel}
                          onChange={(e) => setCourseLevel(e.target.value)}
                          className="tutor-mycourse-input"
                          required
                        >
                          <option value="">Select Level</option>
                          <option value="Beginner">Beginner</option>
                          <option value="Intermediate">Intermediate</option>
                          <option value="Advanced">Advanced</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Duration</Form.Label>
                        {/* <Form.Control
                          name="duration"
                          type="text"
                          value={courseDuration}
                          onChange={(e) => setCourseDuration(e.target.value)}
                          placeholder="E.g., 15 Days"
                          className="tutor-mycourse-input"
                          pattern="\d+\sDays"
                          title="Use format like '15 Days'"
                          required
                        /> */}
                        <Form.Select
                          name="duration"
                          value={courseDuration}
                          onChange={(e) => setCourseDuration(e.target.value)}
                          className="tutor-mycourse-input"
                          required
                        >
                          <option value="">Select Duration</option>
                          {[
                            "7 Days",
                            "10 Days",
                            "15 Days",
                            "20 Days",
                            "30 Days",
                            "45 Days",
                            "60 Days",
                          ].map((duration) => (
                            <option key={duration} value={duration}>
                              {duration}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {/* <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Number of Modules</Form.Label>
                        <Form.Control
                          name="numModules"
                          type="text"
                          value={courseNumModules}
                          onChange={(e) => setCourseNumModules(e.target.value)}
                          placeholder="E.g., 12"
                          className="tutor-mycourse-input"
                          required
                        />
                      </Form.Group>
                    </Col> */}
                  </Row>

                  <Row className="align-items-center">
                    <Col md={8} sm={8} xs={8}>
                      <Button
                        type="submit"
                        className="w-100 tutor-mycourse-create-btn"
                        disabled={isCreateCourseLoading || isEditCourseLoading}
                      >
                        {isCreateCourseLoading || isEditCourseLoading
                          ? editingCourseId
                            ? "Updating..."
                            : "Creating..."
                          : editingCourseId
                            ? "Update Course"
                            : "Create Course"}
                      </Button>
                    </Col>
                    <Col md={4} sm={4} xs={4}>
                      <Button
                        variant="secondary"
                        onClick={handleCloseModal}
                        className="w-100 tutor-mycourse-cancel-btn"
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Module Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={moduleTitle}
                      onChange={(e) => setModuleTitle(e.target.value)}
                      placeholder="E.g., Introduction to React Hooks"
                      className="tutor-mycourse-input"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Description *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={moduleDescription}
                      onChange={(e) => setModuleDescription(e.target.value)}
                      placeholder="Describe what students will learn in this module..."
                      className="tutor-mycourse-textarea"
                      required
                    />
                  </Form.Group>
                  {/* <Form.Group className="mb-3">
                    <Form.Label>Duration</Form.Label>
                    <Form.Control
                      type="text"
                      value={moduleDuration}
                      onChange={(e) => setModuleDuration(e.target.value)}
                      placeholder="E.g., 2 Hours"
                      className="tutor-mycourse-input"
                      required
                    />
                  </Form.Group> */}
                  {/* Attachments */}
                  <Form.Group className="mb-3">
                    <Form.Label>Upload Attachment</Form.Label>
                    <Row className="align-items-center">
                      <Col md={9}>
                        <div className="upload-box">
                          <div className="chips-container">
                            {selectedAttachments.map((att, index) => (
                              <div key={index} className="file-chip">
                                <span>{att.name}</span>
                                <button
                                  type="button"
                                  className="remove-chip-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleRemoveAttachment(index);
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                          </div>

                          <div className="browse-section">
                            <span className="placeholder-text">
                              {selectedAttachments.length === 0
                                ? "No file selected"
                                : ""}
                            </span>
                            <input
                              type="file"
                              ref={attachmentInputRef}
                              onChange={handleAttachmentChange}
                              style={{ display: "none" }}
                              accept=".pdf"
                            />
                          </div>
                        </div>
                      </Col>

                      <Col md={3}>
                        <Button
                          // variant="primary"
                          type="button"
                          onClick={() => attachmentInputRef.current?.click()}
                          className="tutor-mycourse-attach-btn w-100 d-flex align-items-center justify-content-center gap-2"
                        >
                          <FiUpload className="upload-icon" />{" "}
                          <span>Attach</span>
                        </Button>
                      </Col>
                    </Row>
                  </Form.Group>
                  {/* Videos */}
                  <Form.Group className="mb-3">
                    <Form.Label>Upload Videos</Form.Label>
                    <Row className="align-items-center">
                      <Col md={9}>
                        <div className="upload-box">
                          <div className="chips-container">
                            {selectedVideos.map((vid, index) => (
                              <div key={index} className="file-chip">
                                <span>{vid.name}</span>
                                <button
                                  type="button"
                                  className="remove-chip-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleRemoveVideo(index);
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                          </div>

                          <div className="browse-section">
                            <span className="placeholder-text">
                              {selectedVideos.length === 0
                                ? "No files selected"
                                : ""}
                            </span>
                            <input
                              type="file"
                              ref={videoInputRef}
                              onChange={handleVideoChange}
                              style={{ display: "none" }}
                              multiple
                              accept="video/*"
                            />
                          </div>
                        </div>
                      </Col>

                      <Col md={3}>
                        <Button
                          // variant="primary"
                          type="button"
                          onClick={() => videoInputRef.current?.click()}
                          className="tutor-mycourse-browse-btn w-100 d-flex align-items-center justify-content-center gap-2"
                        >
                          <FiUpload className="upload-icon" />{" "}
                          <span>Browse</span>
                        </Button>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Button
                    type="button"
                    className="w-100 tutor-mycourse-create-btn mb-3"
                    onClick={
                      editingModuleIndex !== null &&
                      editingModuleIndex !== undefined
                        ? handleUpdateModule
                        : handleAddModule
                    }
                    disabled={isEditModuleLoading}
                  >
                    {editingModuleIndex !== null &&
                    editingModuleIndex !== undefined
                      ? isEditModuleLoading
                        ? "Updating..."
                        : "Update Module"
                      : "Add Module To Course"}
                  </Button>

                  {modules.length > 0 && (
                    <div className="tutor-mycourse-module-list mt-3">
                      {modules.map((mod, index) => (
                        <div
                          key={`temp-${index}`}
                          className="tutor-mycourse-module-item mb-3 p-3"
                        >
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <span className="tutor-mycourse-module-index">
                                  {String(index + 1).padStart(2, "0")}
                                </span>
                                <h6 className="tutor-mycourse-module-title mb-0 ms-2">
                                  {mod.title}
                                </h6>
                              </div>
                              <p className="small text-muted mb-1">
                                {mod.description}
                              </p>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              {/* <Button
                                variant="link"
                                className="p-0 tutor-mycourse-edit-btn"
                                onClick={() => handleEditLocalModule(index)}
                              >
                                <FaEdit />
                              </Button> */}
                              <Button
                                variant="link"
                                className="p-0 tutor-mycourse-delete-btn"
                                onClick={() => askDeleteLocalModule(index)}
                              >
                                <MdDelete />
                              </Button>
                            </div>
                          </div>

                          {mod.videos?.length > 0 && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {mod.videos.map((video, vidIndex) => (
                                <div
                                  key={`tv-${vidIndex}`}
                                  className="tutor-mycourse-file-item d-flex align-items-center justify-content-between"
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <FaVideo className="tutor-inner-icons" />
                                    <span className="file-name">
                                      {video.name}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          {mod.attachments?.length > 0 && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {mod.attachments.map((file, fileIndex) => (
                                <div
                                  key={`ta-${fileIndex}`}
                                  className="tutor-mycourse-file-item d-flex align-items-center justify-content-between"
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <FaFileAlt className="tutor-inner-icons" />
                                    <span className="file-name">
                                      {file.name}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Bottom Buttons */}
                  {editingModuleIndex === null && (
                    <Row className="align-items-center mt-3">
                      {/* <Col md={3} sm={4} xs={4}>
                        <Button
                          variant="light"
                          onClick={handleBackStep}
                          className="w-100 tutor-mycourse-back-btn"
                        >
                          Back
                        </Button>
                      </Col> */}

                      <Col md={8} sm={4} xs={4}>
                        <Button
                          variant="success"
                          className="w-100 tutor-mycourse-course-btn"
                          onClick={handleCreateModule}
                          disabled={isCreateModuleLoading}
                        >
                          {isCreateModuleLoading
                            ? "Creating..."
                            : "Create Module"}
                        </Button>
                      </Col>

                      <Col md={4} sm={4} xs={4}>
                        <Button
                          variant="secondary"
                          onClick={handleCloseModal}
                          className="w-100 tutor-mycourse-cancel-btn"
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Form>
              )}
            </Modal.Body>
          </>
        ) : (
          // STUDENT PROGRESS modal (reusing showModal)
          <>
            <Modal.Header closeButton className="tutor-mycourse-student-header">
              <Modal.Title className="tutor-mycourse-student-title">
                Student Progress Details
              </Modal.Title>
            </Modal.Header>

            <p className="tutor-mycourse-student-top-para">
              View detailed progress information for{" "}
              {selectedStudent?.profile.full_name || "the student"}
            </p>

            {selectedStudent && (
              <Modal.Body className="tutor-mycourse-student-body">
                <div className="tutor-mycourse-student-info">
                  <div className="tutor-mycourse-student-avatar">
                    {initialsFromName(selectedStudent?.profile?.full_name)}
                  </div>
                  <div className="tutor-mycourse-student-basic">
                    <h6 className="tutor-mycourse-student-name">
                      {selectedStudent?.profile?.full_name}
                    </h6>
                    <small className="tutor-mycourse-student-email">
                      {selectedStudent?.profile?.email}
                    </small>
                  </div>
                </div>

                <div className="tutor-mycourse-student-row two-cols">
                  <div className="tutor-mycourse-student-stat-box">
                    <label className="tutor-mycourse-student-progress-label">
                      Overall Progress
                    </label>
                    <ProgressBar
                      now={parseFloat(selectedStudent.overall_progress || 0)}
                      label={`${selectedStudent.overall_progress || 0}%`}
                      className="tutor-mycourse-student-progress-bar"
                    />
                  </div>

                  <div className="tutor-mycourse-student-stat-box">
                    <small className="tutor-mycourse-student-stat-label">
                      Courses Enrolled
                    </small>
                    <h6 className="tutor-mycourse-student-stat-value">
                      {selectedStudent.profile.enrolled_courses}
                    </h6>
                  </div>
                </div>

                <div className="tutor-mycourse-student-row two-cols">
                  <div className="tutor-mycourse-student-stat-box">
                    <small className="tutor-mycourse-student-stat-label">
                      Final Assignments Completed
                    </small>
                    <h6 className="tutor-mycourse-student-stat-value">
                      {Number(selectedStudent.profile.assignments_completed) ||
                        "-"}
                    </h6>
                  </div>

                  <div className="tutor-mycourse-student-stat-box tutor-mycourse-student-average">
                    <small className="tutor-mycourse-student-average-label">
                      Final Assignments Score
                    </small>
                    <h6 className="tutor-mycourse-student-average-value">
                      {selectedStudent.profile.total_marks}
                    </h6>
                  </div>
                </div>

                <div className="tutor-mycourse-student-activity">
                  <label className="tutor-mycourse-student-activity-label">
                    Recent Activity
                  </label>
                  <ul className="tutor-mycourse-student-activity-list">
                    {selectedStudent.recent_activity?.length > 0 ? (
                      selectedStudent.recent_activity.map((act, i) => (
                        <li
                          key={i}
                          className="tutor-mycourse-student-activity-item"
                        >
                          <span className="tutor-mycourse-student-activity-text">
                            <span
                              className={`tutor-mycourse-activity-dot activity-dot-${
                                i % 3
                              }`}
                            ></span>
                            <span
                              className="tutor-mycourse-course-activity-text"
                              title={`${act.course_title} - ${act.video_title || "No video"} (${act.category_name})`}
                            >
                              {act.course_title} -
                              {act.video_title || "No video"} (
                              {act.category_name})
                            </span>
                          </span>
                          <small className="tutor-mycourse-student-activity-time">
                            {act.activity_time}
                          </small>
                        </li>
                      ))
                    ) : (
                      <li className="tutor-mycourse-student-activity-empty">
                        No recent activity
                      </li>
                    )}
                  </ul>
                </div>
              </Modal.Body>
            )}

            <Modal.Footer className="tutor-mycourse-student-footer">
              <div className="tutor-mycourse-student-grid">
                <div className="tutor-mycourse-grid-col tutor-mycourse-col-8">
                  {/* <Button
                    variant="primary"
                    className="tutor-mycourse-student-btn tutor-mycourse-student-btn-primary w-100"
                  >
                    Send Message
                  </Button> */}
                </div>

                <div className="tutor-mycourse-grid-col tutor-mycourse-col-4">
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    className="tutor-mycourse-student-btn tutor-mycourse-student-btn-secondary w-100"
                  >
                    Close
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>

      {/* Confirm delete module modal  */}
      <Modal
        show={showDeleteModuleModal}
        onHide={handleCancelDeleteModule}
        centered
        className="tutor-mycourser-confirm-yesno-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          className="tutor-mycourser-confirm-yesno-header"
        >
          <Modal.Title className="tutor-mycourser-confirm-yesno-title">
            Confirm Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="tutor-mycourser-confirm-yesno-body">
          Are you sure you want to delete this module?
          <br />
        </Modal.Body>
        <Modal.Footer className="tutor-mycourser-confirm-yesno-footer">
          <Button
            variant="secondary"
            className="tutor-mycourser-confirm-yesno-btn tutor-mycourser-confirm-yesno-btn-no"
            onClick={handleCancelDeleteModule}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="tutor-mycourser-confirm-yesno-btn tutor-mycourser-confirm-yesno-btn-yes"
            onClick={handleConfirmDeleteModule}
            disabled={isDeleteModuleLoading}
          >
            {isDeleteModuleLoading ? "Deleting..." : "Yes, Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirm delete course modal */}
      <Modal
        show={showDeleteCourseModal}
        onHide={handleCancelDeleteCourse}
        centered
        className="tutor-mycourser-confirm-yesno-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          className="tutor-mycourser-confirm-yesno-header"
        >
          <Modal.Title className="tutor-mycourser-confirm-yesno-title">
            Confirm Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="tutor-mycourser-confirm-yesno-body">
          Are you sure you want to delete this course?
          <br />
        </Modal.Body>
        <Modal.Footer className="tutor-mycourser-confirm-yesno-footer">
          <Button
            variant="secondary"
            className="tutor-mycourser-confirm-yesno-btn tutor-mycourser-confirm-yesno-btn-no"
            onClick={handleCancelDeleteCourse}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="tutor-mycourser-confirm-yesno-btn tutor-mycourser-confirm-yesno-btn-yes"
            onClick={handleConfirmDeleteCourse}
            disabled={isDeleteCourseLoading}
          >
            {isDeleteCourseLoading ? "Deleting..." : "Yes, Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Module preview modal  */}
      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        size="lg"
        centered
        className="tutor-preview-modal p-0"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="tutor-preview-header-no-line" />
        {previewData && (
          <Modal.Body className="tutor-preview-body">
            <div className="tutor-preview-big-video-wrap">
              <video
                src={mainVideo?.video_url || ""}
                controls
                controlsList="nodownload"
                disablePictureInPicture
                className="tutor-preview-big-video"
              />
            </div>

            <div className="tutor-mycourse-preview-title-button-section">
              <h5 className="tutor-mycourse-preview-title">
                {previewData.module_title} |
                {mainVideo?.video_title && (
                  <span
                    className="tutor-mycourse-preview-video-title"
                    title={mainVideo.video_title}
                  >
                    {mainVideo?.video_title}
                  </span>
                )}
              </h5>
              <Button
                variant="primary"
                className="tutor-mycourse-preview-download-btn"
                onClick={() => {
                  const pdfUrl = previewData.sheet_file_url;
                  if (pdfUrl) window.open(pdfUrl, "_blank");
                  else showErrorToast("PDF not found for this module.");
                }}
              >
                <BsFiletypePdf className="tutor-mycourse-preview-download-btn-pdf-icon" />{" "}
                Preview PDF
              </Button>
            </div>

            <p className="tutor-mycourse-preview-desc">
              {previewData.module_description}
            </p>

            {mainVideo && (
              <div className="tutor-video-review-section">
                {mainVideo.status?.toLowerCase() === "rejected" && (
                  <div className="tutor-video-review-rejected">
                    <span className="tutor-video-review-rejected-label">
                      Reason for Rejection
                    </span>
                    <span className="tutor-video-review-rejected-value">
                      {mainVideo.reason || "N/A"}
                    </span>
                  </div>
                )}
              </div>
            )}

            <div className="row tutor-preview-small-videos">
              {otherVideos.map((vid, index) => (
                <div key={vid.module_video_id} className="col-md-4 mb-3">
                  <div
                    className="tutor-preview-video-card"
                    onClick={() => swapVideo(vid, index)}
                  >
                    <video
                      src={vid?.video_url}
                      className="tutor-preview-thumb"
                    />
                    <div className="tutor-preview-thumb-card-body">
                      <p
                        className="tutor-preview-thumb-card-text"
                        title={vid.video_title}
                      >
                        {vid.video_title}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        )}
      </Modal>
    </Container>
  );
};

export default TutorMyCourse;
